// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SilverStage__container--ndZYn {
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
}

    @media screen and (min-width: 1024px) {.SilverStage__container--ndZYn {
        max-width: 640px
}
    }

.SilverStage__content--F9Zje {
    display: flex;
    flex-direction: column;
}

@media screen and (max-width: 1023px) {

.SilverStage__content--F9Zje {
        min-height: calc(100vh - 24px)
}
    }

@media screen and (min-width: 1024px) {
        .SilverStage__content--F9Zje.SilverStage__finish--wIwdV {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: calc(100vh - 160px);        
        }
    }

.SilverStage__wrapper--JNFIN {
    overflow: hidden;
    margin-bottom: 12px;
    position: relative;
}

.SilverStage__header--Q4oDs {
    padding: 28px 0 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.SilverStage__logo--x5r_D {
    margin-bottom: 28px;
}

.SilverStage__logo--x5r_D img {
        width: 149px;
        height: 35px;
    }

.SilverStage__rolesListWrapper--dKwgX {
    margin-bottom: 16px;
}

@media screen and (min-width: 1024px) {

.SilverStage__rolesListWrapper--dKwgX {
        overflow: hidden
}
    }

.SilverStage__rolesList--fxzUF {
    display: flex;
    gap: 24px;
    justify-content: center;
    width: 100%;
}

.SilverStage__rolesListItem--YNbDS {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: var(--dark-fourth-new-color);
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    opacity: 0.2;
    flex-shrink: 0;
}

.SilverStage__rolesListItem--YNbDS.SilverStage__active--w57jL {
        opacity: 1;
    }

.SilverStage__rolesListItemName--jFngR {
    font-size: 20px;
    line-height: 24px;
}

.SilverStage__rolesListItemDescription--Nqepf {
    font-size: 12px;
    line-height: 20px;
}

.SilverStage__teamPower--hmKGK {
    margin-top: auto;
}

@media screen and (max-width: 1023px) {

.SilverStage__teamPower--hmKGK {
        position: sticky;
        bottom: 0;
        left: 0;
        margin-top: auto;
        background: linear-gradient(0deg, #181819 68.12%, rgba(24, 24, 25, 0.00) 100%);
        padding: 16px;
        width: calc(100% + 32px);
        z-index: 20;
        margin-left: -16px
}
    }

.SilverStage__teamPowerTitle--We6wJ {
    color: #94A5CD;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (min-width: 1024px) {

.SilverStage__teamPowerTitle--We6wJ {
        font-size: 20px;
        line-height: 28px
}
    }

.SilverStage__footer--hmn_k {
    margin-top: 68px;
}

.SilverStage__footerWrapper--H6pUf {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.SilverStage__imageDecor--sNdvK {
    width: 126px;
    height: 6px;
    margin: 0 auto;
    display: block;
}

.SilverStage__imageDecor--sNdvK.SilverStage__top--Lm5f0 {
        margin-bottom: 24px;
    }

.SilverStage__imageDecor--sNdvK.SilverStage__bottom--tDWVO {
        margin-top: 24px;
    }

.SilverStage__imageWinner--niDio {
    width: 100%;
    max-width: 348px;
    height: auto;
    aspect-ratio: 3.6 / 4.85;
    display: block;
    margin: 0 auto;
}

@media screen and (max-width: 518px) {

.SilverStage__imageWinner--niDio {
        width: calc(100% + 32px)
}
    }

@media screen and (max-width: 375px) {

.SilverStage__imageWinner--niDio {
        max-width: 320px
}
    }

@media screen and (min-width: 1024px) {

.SilverStage__imageWinner--niDio {
        margin-bottom: 60px
}
    }

.SilverStage__footerFinish--Y7yuh {
    position: fixed;
    padding: 16px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 360px;
}

@media screen and (max-width: 518px) {

.SilverStage__footerFinish--Y7yuh {
        max-width: 100%
}
    }

@media screen and (min-width: 1024px) {

.SilverStage__footerFinish--Y7yuh {
        position: static;
        max-width: 312px;
        transform: none;
        padding: 0;
        margin: 0 auto
}
    }

/* modal */
.SilverStage__overlay--EfahO {
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-backdrop-filter: blur(22px);
            backdrop-filter: blur(22px);
}

.SilverStage__modal--KUKZb {
    background-color: transparent;
    border: none;
    box-shadow: none;
    width: 100vw;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 28px;
}

.SilverStage__modalImage--otlic {
    width: 160px;
    height: 160px;
    opacity: 0;
    transition: opacity 0.15s linear;
    transition-delay: 0.1s;
}

.SilverStage__modalImage--otlic.SilverStage__withAnimation--EzywD {
        opacity: 1;
    }

.SilverStage__modalText--eRGXe {
    color: var(--tertiary-color);
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    max-width: 312px;
    display: block;
}

@media screen and (min-width: 1024px) {

.SilverStage__modalText--eRGXe {
        font-size: 22px;
        line-height: 28px
}
    }

.SilverStage__modalTextUppercase--uuAqa {
    text-transform: uppercase;
}

.SilverStage__modalWrapper--st20x {
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transition: opacity 0.15s linear;
    transition-delay: 0.35s;
}

.SilverStage__modalWrapper--st20x.SilverStage__withAnimation--EzywD {
        opacity: 1;
    }

.SilverStage__modalFooter--z6RUD {
    position: absolute;
    padding: 24px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 360px;
}

.SilverStage__modalFooter--z6RUD.SilverStage__withChildren--FzNpp {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 16px;
    }

@media screen and (max-width: 518px) {

.SilverStage__modalFooter--z6RUD {
        max-width: 100%
}
    }

.SilverStage__fullButton--Abm2L {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Plelander/SilverStage/SilverStage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AAKf;;IAHI,uCALJ;QAMQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;AAc1B;;AAZI;;AAJJ;QAKQ;AAWR;IAVI;;AAEA;QACI;YACI,aAAa;YACb,sBAAsB;YACtB,8BAA8B;YAC9B,+BAA+B;QACnC;IACJ;;AAGJ;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AAMvB;;AAJI;QACI,YAAY;QACZ,YAAY;IAChB;;AAGJ;IACI,mBAAmB;AAKvB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mCAAmC;IACnC,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAKlB;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AAapB;;AAXI;;AAHJ;QAIQ,gBAAgB;QAChB,SAAS;QACT,OAAO;QACP,gBAAgB;QAChB,8EAA8E;QAC9E,aAAa;QACb,wBAAwB;QACxB,WAAW;QACX;AAER;IADI;;AAGJ;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AAMtB;;AAJI;;AATJ;QAUQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,cAAc;AASlB;;AAPI;QACI,mBAAmB;IACvB;;AAEA;QACI,gBAAgB;IACpB;;AAGJ;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,cAAc;IACd,cAAc;AAalB;;AAXI;;AARJ;QASQ;AAUR;IATI;;AAEA;;AAZJ;QAaQ;AAMR;IALI;;AAEA;;AAhBJ;QAiBQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AAapB;;AAXI;;AATJ;QAUQ;AAUR;IATI;;AAEA;;AAbJ;QAcQ,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,UAAU;QACV;AAER;IADI;;AAGJ,UAAU;AACV;IACI,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gCAAgC;IAChC,sBAAsB;AAK1B;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAMlB;;AAJI;;AARJ;QASQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gCAAgC;IAChC,uBAAuB;AAK3B;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AAWpB;;AATI;QACI,aAAa;QACb,8BAA8B;QAC9B,cAAc;IAClB;;AAEA;;AAfJ;QAgBQ;AAER;IADI;;AAGJ;IACI,WAAW;AACf","sourcesContent":[".container {\n    max-width: 400px;\n    margin: 0 auto;\n    width: 100%;\n\n    @media (--large) {\n        max-width: 640px;\n    }\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n\n    @media (--mobile) {\n        min-height: calc(100vh - 24px);\n    }\n\n    @media (--large) {\n        &.finish {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            min-height: calc(100vh - 160px);        \n        }\n    }\n}\n\n.wrapper {\n    overflow: hidden;\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.header {\n    padding: 28px 0 52px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logo {\n    margin-bottom: 28px;\n\n    img {\n        width: 149px;\n        height: 35px;\n    }\n}\n\n.rolesListWrapper {\n    margin-bottom: 16px;\n\n    @media (--large) {\n        overflow: hidden;\n    }\n}\n\n.rolesList {\n    display: flex;\n    gap: 24px;\n    justify-content: center;\n    width: 100%;\n}\n\n.rolesListItem {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    color: var(--dark-fourth-new-color);\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: 700;\n    opacity: 0.2;\n    flex-shrink: 0;\n\n    &.active {\n        opacity: 1;\n    }\n}\n\n.rolesListItemName {\n    font-size: 20px;\n    line-height: 24px;\n}\n\n.rolesListItemDescription {\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.teamPower {\n    margin-top: auto;\n\n    @media (--mobile) {\n        position: sticky;\n        bottom: 0;\n        left: 0;\n        margin-top: auto;\n        background: linear-gradient(0deg, #181819 68.12%, rgba(24, 24, 25, 0.00) 100%);\n        padding: 16px;\n        width: calc(100% + 32px);\n        z-index: 20;\n        margin-left: -16px;\n    }\n}\n\n.teamPowerTitle {\n    color: #94A5CD;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n    }\n}\n\n.footer {\n    margin-top: 68px;\n}\n\n.footerWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.imageDecor {\n    width: 126px;\n    height: 6px;\n    margin: 0 auto;\n    display: block;\n\n    &.top {\n        margin-bottom: 24px;\n    }\n\n    &.bottom {\n        margin-top: 24px;\n    }\n}\n\n.imageWinner {\n    width: 100%;\n    max-width: 348px;\n    height: auto;\n    aspect-ratio: 3.6 / 4.85;\n    display: block;\n    margin: 0 auto;\n\n    @media (--tiny-only) {\n        width: calc(100% + 32px);\n    }\n\n    @media screen and (max-width: 375px) {\n        max-width: 320px;\n    }\n\n    @media (--large) {\n        margin-bottom: 60px;\n    }\n}\n\n.footerFinish {\n    position: fixed;\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 360px;\n\n    @media (--tiny-only) {\n        max-width: 100%;\n    }\n\n    @media (--large) {\n        position: static;\n        max-width: 312px;\n        transform: none;\n        padding: 0;\n        margin: 0 auto;\n    }\n}\n\n/* modal */\n.overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(22px);\n}\n\n.modal {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    width: 100vw;\n    height: 100vh;\n    max-width: 100%;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 28px;\n}\n\n.modalImage {\n    width: 160px;\n    height: 160px;\n    opacity: 0;\n    transition: opacity 0.15s linear;\n    transition-delay: 0.1s;\n\n    &.withAnimation {\n        opacity: 1;\n    }\n}\n\n.modalText {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n    max-width: 312px;\n    display: block;\n\n    @media (--large) {\n        font-size: 22px;\n        line-height: 28px;\n    }\n}\n\n.modalTextUppercase {\n    text-transform: uppercase;\n}\n\n.modalWrapper {\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    opacity: 0;\n    transition: opacity 0.15s linear;\n    transition-delay: 0.35s;\n\n    &.withAnimation {\n        opacity: 1;\n    }\n}\n\n.modalFooter {\n    position: absolute;\n    padding: 24px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 360px;\n\n    &.withChildren {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 16px;\n    }\n\n    @media (--tiny-only) {\n        max-width: 100%;\n    }\n}\n\n.fullButton {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SilverStage__container--ndZYn`,
	"content": `SilverStage__content--F9Zje`,
	"finish": `SilverStage__finish--wIwdV`,
	"wrapper": `SilverStage__wrapper--JNFIN`,
	"header": `SilverStage__header--Q4oDs`,
	"logo": `SilverStage__logo--x5r_D`,
	"rolesListWrapper": `SilverStage__rolesListWrapper--dKwgX`,
	"rolesList": `SilverStage__rolesList--fxzUF`,
	"rolesListItem": `SilverStage__rolesListItem--YNbDS`,
	"active": `SilverStage__active--w57jL`,
	"rolesListItemName": `SilverStage__rolesListItemName--jFngR`,
	"rolesListItemDescription": `SilverStage__rolesListItemDescription--Nqepf`,
	"teamPower": `SilverStage__teamPower--hmKGK`,
	"teamPowerTitle": `SilverStage__teamPowerTitle--We6wJ`,
	"footer": `SilverStage__footer--hmn_k`,
	"footerWrapper": `SilverStage__footerWrapper--H6pUf`,
	"imageDecor": `SilverStage__imageDecor--sNdvK`,
	"top": `SilverStage__top--Lm5f0`,
	"bottom": `SilverStage__bottom--tDWVO`,
	"imageWinner": `SilverStage__imageWinner--niDio`,
	"footerFinish": `SilverStage__footerFinish--Y7yuh`,
	"overlay": `SilverStage__overlay--EfahO`,
	"modal": `SilverStage__modal--KUKZb`,
	"modalImage": `SilverStage__modalImage--otlic`,
	"withAnimation": `SilverStage__withAnimation--EzywD`,
	"modalText": `SilverStage__modalText--eRGXe`,
	"modalTextUppercase": `SilverStage__modalTextUppercase--uuAqa`,
	"modalWrapper": `SilverStage__modalWrapper--st20x`,
	"modalFooter": `SilverStage__modalFooter--z6RUD`,
	"withChildren": `SilverStage__withChildren--FzNpp`,
	"fullButton": `SilverStage__fullButton--Abm2L`
};
export default ___CSS_LOADER_EXPORT___;
